import React, {ReactElement, SVGProps} from 'react';
import cn from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';

// Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc.
interface PinIconProps extends SVGProps<SVGSVGElement> {
  tooltip?: ReactElement | string;
}

export const PinIcon: React.FC<PinIconProps> = props => {
  return (
    <Tooltip title={props.tooltip ?? ''}>
      <svg
        {...props}
        className={cn(props.className, 'icon pin thumbtack')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 384 512">
        <path d="M168 352H32C22.15 352 12.84 347.5 6.778 339.7C.7133 331.9-1.434 321.8 .9555 312.2L7.202 287.3C17.51 246 42.58 211.5 75.93 188.9L86.77 48H56C51.56 48 47.41 46.8 43.84 44.7C36.76 40.53 32 32.82 32 24C32 10.75 42.75 0 56 0H328C341.3 0 352 10.75 352 24C352 32.82 347.2 40.53 340.2 44.7C336.6 46.8 332.4 48 328 48H297.2L308.1 188.9C341.4 211.5 366.5 246 376.8 287.3L383 312.2C385.4 321.8 383.3 331.9 377.2 339.7C371.2 347.5 361.9 352 352 352H216V488C216 501.3 205.3 512 191.1 512C178.7 512 167.1 501.3 167.1 488L168 352zM122 215.7L102.9 228.7C79.01 244.8 61.13 269.4 53.77 298.9L52.49 304H168V216C168 202.7 178.7 192 192 192C205.3 192 216 202.7 216 216V304H331.5L330.2 298.9C322.9 269.4 304.1 244.8 281.1 228.7L261.1 215.7L249.1 48H134.9L122 215.7z" />
      </svg>
    </Tooltip>
  );
};
